export default {
  descricao: {
    value: null,
    maxlength: 200,
    required: true,
    state: null
  },
  items: {
    value: [],
    required: false,
    state: null
  },
  empresaID: {
    value: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/layouts/layout-form.js